import { useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";

import { X } from "@phosphor-icons/react";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onRegenerate: (prompt: string) => void;
}

const RegenerateModal = ({ isOpen, onClose, onRegenerate }: Props) => {
  const [prompt, setPrompt] = useState("");

  const handleRegenerate = () => {
    onRegenerate(prompt);
    setPrompt("");
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="md"
      fullWidth
    >
      <DialogTitle
        sx={{
          px: 3,
          py: 1.5,
        }}
      >
        <Typography variant="text14B">Regenerate this resource?</Typography>
        <IconButton
          aria-label="Close regenerate dialog"
          onClick={onClose}
          sx={{
            position: "absolute",
            top: -24,
            right: -24,
            color: "common.white",
          }}
        >
          <X size={18} weight="bold" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography
          variant="text13L"
          color="text.secondary"
          sx={{
            whiteSpace: "pre-wrap",
            mb: 2,
          }}
        >
          What would you like to change about this resource?
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          value={prompt}
          onChange={(e) => setPrompt(e.target.value)}
          placeholder="e.g. make the question easier and use simpler numbers"
          sx={{ mb: 1 }}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3, pt: 1, gap: 1 }}>
        <Button
          onClick={handleRegenerate}
          variant="contained"
          disabled={!prompt.trim()}
          sx={{
            borderRadius: 1.5,
            px: 3,
            backgroundColor: "secondary.main",
            "&:hover": {
              backgroundColor: "brand.green",
            },
          }}
        >
          Regenerate
        </Button>
        <Button
          onClick={onClose}
          variant="outlined"
          color="secondary"
          sx={{
            borderRadius: 1.5,
            px: 3,
          }}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RegenerateModal;
